/*
 * Copyright (c) 2021 SARL SIGMA POLYNESIA
 */

import { PropsWithChildren } from 'react'
import FormattedFileSize from '../../../client/js/components/FormattedFileSize'
import { Box, BoxProps, Card, Image, Stack, Text } from '@mantine/core'

export type PhotoThumbnailProps = PropsWithChildren & BoxProps & {
  photo: EstatePhoto,
}

function PhotoThumbnail (props: PhotoThumbnailProps) {
  const {
    children,
    photo,
    ...others
  } = props

  return (
    <Card withBorder shadow="none" {...others}>
      <Card.Section bg="gray.0">
        <Image
          alt={photo.name}
          src={photo.url}
          height={150}
        />
      </Card.Section>
      <Stack gap="xs" mt="sm" style={{ flexGrow: 1 }}>
        <Box ta="center" fz="sm">
          <Text
            inherit
            style={{
              textOverflow: 'ellipsis',
              overflow: 'hidden',
              maxWidth: '100%',
              display: 'inline-block'
            }}
            title={photo.name}
          >
            {photo.name}
          </Text>
          <Text inherit c="dimmed">
            <FormattedFileSize value={photo.size} />
          </Text>
        </Box>

        {children}
      </Stack>
    </Card>
  )
}

export default PhotoThumbnail
